import { AxiosResponse } from 'axios';
import { HttpResponse } from 'shell/models/http-response';
import { Job } from 'shell/models/job-item';
import { BatchManagementForm } from 'system/components/batch-management/form';

export const transformerJob = (
  response: AxiosResponse<HttpResponse<Job>>,
  disabled?: boolean
): BatchManagementForm => {
  const data: Job = response?.data?.payload || {};
  const schedules = data?.schedules?.map((item) => ({
    cronExpression: item?.cronExpression,
    description: item?.description,
    schedulationType: item?.type,
    eventSourceJobName: item?.eventSourceJobName,
    event: item?.event,
    hidden: {
      edit: disabled || false,
      delete: disabled || false,
      read: disabled || false,
    },
  }));

  const parameters = data?.parameters?.map((item, index) => ({
    code: String(index + 1),
    name: item?.name,
    description: item?.description,
    value: item?.value,
    hidden: {
      edit: disabled || false,
      delete: disabled || false,
      read: disabled || false,
    },
  }));
  const res: BatchManagementForm = {
    id: data?.name || '',
    batchName: data?.name || '',
    description: data?.description || '',
    active: data?.enabled || false,
    microservice: data?.executorLocation || '',
    postCalculation: data?.postExecutionMailAction || '',
    executionText: data?.executorName || '',
    mailingList: data?.mailingList || '',
    inputFolder: data?.nmCartellaInput || '',
    outputFolder: data?.nmCartellaOutput || '',
    parameters: parameters || [],
    schedulations: schedules || [],
  };
  return res;
};
